import React, { useState } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { REQUESTS_STATUSES } from 'constants/amcStatuses';
import { StyledtBlocWrapper } from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/styles';
import {
  StyledTabs,
  StyledTab,
} from 'containers/AmcDetailsPage/FollowUpMyRequestsTab/MyRequests/styles';
import Requests from 'components/Requests';
import { translate } from 'helpers/intl';
import messages from './messages';

function a11yProps(index: number) {
  return {
    id: `my-contracts-tab-${index}`,
    'aria-controls': `my-contracts-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
}

const MyRequests = ({ ...props }: { intl: IntlShape }) => {
  const [expandeds, setExpanded] = useState<boolean | String>(false);
  const [value, setValue] = React.useState(0);
  //const [claimNumber, setClaimNumber] = useState<String>('');
  const handleChange = (index: String, claimNumber: String) => (
    event: React.ChangeEvent<{}>,
    isExpanded: boolean,
  ) => {
    //if (isExpanded) setClaimNumber(claimNumber);
    setExpanded(isExpanded ? index : false);
  };

  const handleChangeTab = (event: React.ChangeEvent<{}>, newValue: number) => {
    // eslint-disable-next-line
    setValue(newValue);
  };

  const requests = [
    {
      NUM_DECLMARATION: '2871161',
      NOM_PRENOM_ASSURE: 'Name 1',
      SORT: 'CRÉÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2000,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '2871161',
      NOM_PRENOM_ASSURE: 'Name 1',
      SORT: 'REJETÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2000,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '2871161',
      NOM_PRENOM_ASSURE: 'Name 1',
      SORT: 'VALIDÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2000,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '862751',
      NOM_PRENOM_ASSURE: 'Name 3',
      SORT: 'VALIDÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 300,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '862751',
      NOM_PRENOM_ASSURE: 'Name 3',
      SORT: 'VALIDÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 300,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '209271',
      NOM_PRENOM_ASSURE: 'Name 2',
      SORT: 'VALIDÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2200,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '209271',
      NOM_PRENOM_ASSURE: 'Name 2',
      SORT: 'REJETÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2200,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '209271',
      NOM_PRENOM_ASSURE: 'Name 2',
      SORT: 'REJETÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2200,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '209271',
      NOM_PRENOM_ASSURE: 'Name 2',
      SORT: 'REJETÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2200,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
    {
      NUM_DECLMARATION: '209271',
      NOM_PRENOM_ASSURE: 'Name 2',
      SORT: 'CRÉÉE',
      reasonReject: 'Maladie non prise en charge',
      MONTANT_REGLE: 2200,
      FRAIS_ENGAGE: 120,
      DATE_SURVENANCE: '01/01/2019',
      DATE_REGLEMENT: '20/01/2019',
      RIB: 'fake-rib',
      MODE_REGLEMENT: 'Virement',
      NUM_SINISTRE: 'fake-num-sinistre',
    },
  ];

  const tabItems = [
    {
      label: translate({ ...messages.allRequests }, props),
    },
    {
      label: translate({ ...messages.createdRequests }, props),
    },
    {
      label: translate({ ...messages.validatedRequests }, props),
    },
    {
      label: translate({ ...messages.rejectedRequests }, props),
    },
  ];

  const getListRquests = () => {
    switch (value) {
      case 1:
        return requests.filter(
          (item) => item.SORT === REQUESTS_STATUSES.CREATED,
        );
      case 2:
        return requests.filter(
          (item) => item.SORT === REQUESTS_STATUSES.VALIDATED,
        );
      case 3:
        return requests.filter(
          (item) => item.SORT === REQUESTS_STATUSES.REJECTED,
        );
      default:
        return requests;
    }
  };

  return (
    <StyledtBlocWrapper height="auto">
      <StyledTabs
        value={value}
        onChange={handleChangeTab}
        aria-label="my contracts tabs"
      >
        {tabItems.map((tab: tabItemProps, index) => (
          <StyledTab
            key={index}
            label={tab.label}
            {...a11yProps(index)}
            disableRipple
          />
        ))}
      </StyledTabs>
      <Requests
        listIndex={0}
        isLoading={false}
        requests={getListRquests()}
        expanded={expandeds}
        handleChange={(index: String, claimNumber: String) =>
          handleChange(index, claimNumber)
        }
      />
    </StyledtBlocWrapper>
  );
};
export default injectIntl(MyRequests);
